import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpHandlerService {
 
  headers: any;
  constructor(private http: HttpClient) { 
    let header = new HttpHeaders({'Content-Type': 'application/json'});
    this.headers = {headers: header};

  }

  /** get method http */
  get(url: any, options? : any){
    return this.http.get(url, options);
  }

   /** post method http */
  post(url: any, param? : any, headers? : any){
    return this.http.post<any>(url, param, headers);
  }

   /** put method http */
  put(url: any, param? : any, headers? : any){
    return this.http.put<any>(url, param, headers);
  }
 
   /** delete method http */
  delete(url: any, options? : any){
    return this.http.delete(url, options);
  }
}
